/* Only show navigation items whose destination is present on this page. */
(() => {
  if (window.ggcLearnNavigationReady) return;
  window.ggcLearnNavigationReady = true;
  function syncNavigation() {
    document.querySelectorAll('[data-ggc-learn-nav]').forEach((nav) => {
      const links = Array.from(nav.querySelectorAll('a'));
      links.forEach((link) => {
        const anchor = (link.getAttribute('href') || '').slice(1);
        const target = anchor ? document.getElementById(anchor) : null;
        link.hidden = !target;
      });
      nav.hidden = !links.some((link) => !link.hidden);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncNavigation, { once: true });
  } else syncNavigation();
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((event) => {
    document.addEventListener(event, () => requestAnimationFrame(syncNavigation));
  });
})();
